import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CarouselConfig } from 'ngx-bootstrap/carousel';

@Component({
  selector: 'app-home',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [{ provide: CarouselConfig, useValue: { interval: 7500, noPause: false, showIndicators: true } }],
})
export class LoginComponent implements OnInit {
  public currentDate;
  public currentYear = null;

  public slides = [
    { image: '/assets/img/login/2.png', text: 'Second Slide' },
    { image: '/assets/img/login/1.png', text: 'First Slide' },
  ];

  //input variables
  public user: {
    username: string;
    password: string;
  } = {
    username: '',
    password: '',
  };
  public errMsg: string = '';
  constructor(
    private scroller: ViewportScroller,
    private translateService: TranslateService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const currentLang = this.translateService.currentLang;
    this.currentDate = this.getCurrentDate(currentLang);
    this.translateService.onLangChange.subscribe(response => {
      this.currentDate = this.getCurrentDate(response.lang);
    });
    const date = new Date();
    this.currentYear = date.getFullYear();
  }

  private getCurrentDate(lang) {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const yyyy = today.getFullYear();

    let date;
    let mm;
    if (lang == 'es') {
      mm = today.toLocaleString('es-ES', { month: 'long' });
      const capitalizeMonth = mm.charAt(0).toUpperCase() + mm.slice(1);
      date = dd + ' de ' + capitalizeMonth + ' ' + yyyy;
    } else if (lang == 'en') {
      mm = today.toLocaleString('en-EN', { month: 'long' });
      const capitalizeMonth = mm.charAt(0).toUpperCase() + mm.slice(1);
      date = dd + ' of ' + capitalizeMonth + ' ' + yyyy;
    }
    return date;
  }

  public scroll(el) {
    this.scroller.scrollToAnchor(el);
  }

  public login() {
    this.authService.login();
    // const validation = this.validateFields();

    // if (!validation) {
    //   console.log(validation);
    //   this.errMsg = 'Invalid credentials.';
    //   return;
    // }

    // this.authService.login(this.user).subscribe({
    //   next: res => {
    //     let defaultGo = '/dashboard';
    //     if (res.actionsRequired && res.actionsRequired.updatePassword) {
    //       defaultGo = '/update-password';
    //     }
    //     this.router.navigate([defaultGo]);
    //   },
    //   error: err => {
    //     if (err && err.error) {
    //       this.errMsg = err.error;
    //     }
    //   },
    // });
  }
  private validateFields(): boolean {
    if (this.user.username == '' || this.user.password == '') {
      return false;
    }
    return true;
  }
  public handleKeyboardEvent(event) {
    if (event.keyCode === 13) {
      this.login();
    }
  }

  public sendEmail() {
    window.location.href = 'mailto:sales@3ddigitalvenue.com.com';
  }
}
